import type { SelectResult } from './worker/protocol';

const TITLE_MAX = 36;

/** A run lives forever in the result-tabs strip until evicted. */
export interface ResultEntry {
  id: string;
  /** SQL the user actually ran (statement-at-cursor or whole buffer). */
  sql: string;
  /** Still in-flight. While true, result/error/message/tookMs are null. */
  pending: boolean;
  result: SelectResult | null;
  error: string | null;
  message: string | null;
  tookMs: number | null;
  ts: number;
}

/** A virtual SQL "file" in the editor tab strip. Per-session — not persisted. */
export interface EditorTab {
  id: string;
  title: string;
  sql: string;
}

/** Render-friendly title for a query: first non-comment line, truncated. */
export function titleForSql(sql: string, fallback = 'Query'): string {
  const cleaned = sql
    .split('\n')
    .map((line) => line.replace(/^\s*--.*$/, '').trim())
    .filter(Boolean)
    .join(' ');
  if (!cleaned) return fallback;
  return cleaned.length > TITLE_MAX ? cleaned.slice(0, TITLE_MAX - 1) + '…' : cleaned;
}

/** Stable-enough id for tabs/results. crypto.randomUUID exists everywhere
 *  the rest of the app runs (Workers, modern browsers); fall back to a
 *  monotonic counter just in case. */
let _idSeq = 0;
export function newId(prefix: string): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return `${prefix}-${crypto.randomUUID()}`;
  }
  return `${prefix}-${++_idSeq}-${Date.now()}`;
}
